import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";

import fondoImg from "../../static/media/nosotros/fondo.webp";

const C = {
  dark: "#0C1F2F",
  navy: "#0057A8",
  gold: "#FFCD00",
  white: "#ffffff",
};

export default function QuienesSomos() {
  return (
    <Box
      id="quienes-somos"
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh", // Hace que la sección ocupe toda la pantalla
        pt: { xs: "60px", md: "80px" },
        pb: { xs: "25vw", md: "12vw" }, // Espacio reservado para la ola inferior
        overflow: "hidden",
      }}
    >
      {/* IMAGEN DE FONDO */}
      <Box
        component="img"
        src={fondoImg}
        alt="Equipo de trabajo Eléctrica GRM"
        sx={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />

      {/* OVERLAY CON BLUR PARA LEGIBILIDAD */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: "rgba(12, 31, 47, 0.75)",
          backdropFilter: "blur(6px)",
          zIndex: 1,
        }}
      />

      {/* CONTENIDO CENTRAL */}
      <Box
        sx={{
          maxWidth: "900px",
          mx: "auto",
          px: { xs: 3, md: 5 },
          width: "100%",
          zIndex: 2,
          position: "relative",
          boxSizing: "border-box",
        }}
      >
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          sx={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Typography
            variant="h2"
            sx={{
              color: C.white,
              fontWeight: 750,
              fontSize: { xs: 28, sm: 34, md: 40 },
              lineHeight: 1.1,
              letterSpacing: "-.02em",
              mb: 2,
              width: "100%",
              textAlign: "center",
            }}
          >
            Más que distribuidores, su socio estratégico
          </Typography>

          {/* Línea horizontal añadida */}
          <Box
            sx={{
              width: "60px",
              height: "3px",
              background: C.gold,
              borderRadius: "2px",
              mb: 5,
            }}
          />

          <Typography
            sx={{
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: { xs: 14, md: 16 },
              fontWeight: 500,
              lineHeight: 1.8,
              mb: 3,
            }}
          >
            En{" "}
            <Box component="span" sx={{ color: C.gold, fontWeight: 700 }}>
              ELÉCTRICA GRM
            </Box>{" "}
            somos distribuidores de las mejores marcas de material eléctrico y
            les damos la bienvenida a nuestro sitio web, implementado para
            brindar un servicio más rápido y eficiente.
          </Typography>

          <Typography
            sx={{
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: { xs: "1.05rem", md: "1.2rem" },
              fontWeight: 500,
              lineHeight: 1.8,
            }}
          >
            Ponemos a su disposición lo más avanzado en automatización, control,
            material eléctrico industrial y residencial. Contamos con personal
            calificado para brindar soporte en sus instalaciones.
          </Typography>
        </Box>
      </Box>

      {/* CURVA SINUOSA - Conecta hacia Misión y Visión (Fondo Blanco) */}
      <Box
        sx={{
          position: "absolute",
          bottom: -1,
          left: 0,
          width: "100%",
          overflow: "hidden",
          lineHeight: 0,
          zIndex: 10,
          transform: "translateY(2px)",
        }}
      >
        <svg
          viewBox="0 0 1440 320"
          style={{
            display: "block",
            width: "100%",
            height: "10vw",
            minHeight: "60px",
          }}
          preserveAspectRatio="none"
        >
          <path
            fill={C.white}
            d="M0,224L80,213.3C160,203,320,181,480,186.7C640,192,800,224,960,218.7C1120,213,1280,171,1360,149.3L1440,128L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
          ></path>
        </svg>
      </Box>
    </Box>
  );
}
